export const ChartColors: string[] = [
  '#D49DF3', // Purple
  '#1170FF', // primary blue
  '#A0C6FF', // grey blue
  '#84F9FE', // Turqoiuse
  '#924BBA',
];
